import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MultiFunctionTable from 'multi-function-table'
import ElementUI from 'element-ui'
import '@/styles/public.scss'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(MultiFunctionTable)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
